import React from "react";
import { Link } from "react-router-dom";
import { Card, Col, Row } from "react-bootstrap";
import "./../../containers/public/Home.css";

const ADMIN_SECTIONS = [
  {
    title: "Students / Appointments",
    groups: [
      {
        subtitle: "Road Tests",
        links: [
          { to: "/roadTestDates", label: "Manage Road Test Dates" },
          { to: "/appointments", label: "Manage Appointments" },
          { to: "/attendeelist", label: "Print Road Test Schedule / Roster" },
        ],
      },
      {
        subtitle: "Configuration",
        links: [
          { to: "/roadTestPackages", label: "Manage Packages Offered" },
          { to: "/roadTestLocations", label: "Manage Lesson Locations" },
        ],
      },
      {
        subtitle: "Student Records",
        links: [
          { to: "/modify", label: "Modify Student Data" },
          { to: "/studentTable", label: "View All Student Data" },
          { to: "/transactions", label: "View Yearly Transaction Data" },
        ],
      },
    ],
  },
  {
    title: "Student Lessons",
    groups: [
      {
        subtitle: "Road Lessons",
        links: [
          { to: "/manageRoadLessons", label: "Add / Manage Road Lessons" },
          { to: "/viewAllRoadLessons", label: "View All Road Lessons" },
          { to: "/roadLessonInstructors", label: "Manage Road Lesson Instructors" },
        ],
      },
    ],
  },
];

export default function Admin() {
  return (
    <div className="holder">
      <div style={{ marginBottom: "1.75rem" }}>
        <h2 style={{ marginBottom: "0.25rem" }}>Administration</h2>
        <p className="text-muted" style={{ marginBottom: 0 }}>
          Welcome, administrator. Select a section below to get started.
        </p>
      </div>

      <Row>
        {ADMIN_SECTIONS.map((section) => (
          <Col key={section.title} md={6} style={{ marginBottom: "1.5rem" }}>
            <Card className="h-100">
              <Card.Header>
                <strong>{section.title}</strong>
              </Card.Header>
              <Card.Body style={{ padding: "1.25rem" }}>
                {section.groups.map((group, i) => (
                  <div
                    key={group.subtitle}
                    className="admin-group"
                    style={i < section.groups.length - 1 ? { marginBottom: "1.25rem", paddingBottom: "1.25rem", borderBottom: "1px solid #dee2e6" } : { marginBottom: 0 }}
                  >
                    <div className="admin-group__subtitle">{group.subtitle}</div>
                    <nav className="admin-nav">
                      {group.links.map(({ to, label }) => (
                        <Link key={to} to={to} className="btn btn-outline-primary btn-sm admin-nav__link">
                          {label}
                        </Link>
                      ))}
                    </nav>
                  </div>
                ))}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
